export default {
  baseURL: "https://vagaintegral.itajai.sc.gov.br/servicos",
  baseURLErudio: "https://erudio-api.itajai.sc.gov.br/api",
  estadoDefault: {
    nome: "Santa Catarina",
  },
  cidadeDefault: {
    nome: "Itajaí",
  },
  dataInicio: "yyyy-MM-dd",
  dataEncerramento: "yyyy-MM-dd",
};
